export type SustainabilityRatingMeasureId = number;
export const ENERGY_MEASURE_ID: SustainabilityRatingMeasureId = 2;


export interface SustainabilityRatingMeasure {
  sustainability_rating_measure_id: SustainabilityRatingMeasureId;
  name: string;
}

export class SustainabilityRatingMeasureImpl implements SustainabilityRatingMeasure {
  sustainability_rating_measure_id: SustainabilityRatingMeasureId;
  name: string;
}